import { Injectable } from '@angular/core';
import { PartnerCampaignCollateral } from '@core/models/partner-campaign.model';
import { HttpRestService } from '@core/services/http-rest.service';
import { APIResponse } from '@yourcause/common';
import { catchError, map, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PartnerCampaignResources {

  constructor (
    private httpRestService: HttpRestService
  ) { }

  getPartnerCampaignCollateral () {
      return this.httpRestService.Get<APIResponse<PartnerCampaignCollateral>>('api/NonprofitPartner/GetCollateral')
        .pipe(
          map(e => e.data),
          catchError((error) => {
            console.log("Error fetching Partner Campaign Collateral", error);

            return of(null);
          })
        );
  }

  updateCollateralImpression (
    partnerCampaignCollateralId: number
  ) {
    return this.httpRestService.Post('api/NonprofitPartner/UpdateCollateral',
      {
        partnerCampaignCollateralId
      })
      .pipe(
        map(_ => true),
        catchError((error) => {
            console.log("Error updating Partner Campaign Collateral", error);

            return of(null);
          })
      );
  }
}
